import { render, staticRenderFns } from "./program-charts.vue?vue&type=template&id=0d11e1fe&"
import script from "./program-charts.vue?vue&type=script&lang=ts&"
export * from "./program-charts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports